import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=1d9d1daa&scoped=true"
import script from "./Termos.vue?vue&type=script&lang=js"
export * from "./Termos.vue?vue&type=script&lang=js"
import style0 from "./Termos.vue?vue&type=style&index=0&id=1d9d1daa&prod&lang=css"
import style1 from "./Termos.vue?vue&type=style&index=1&id=1d9d1daa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d1daa",
  null
  
)

export default component.exports